import { PropTypes } from "aem/ComponentWrapper";

export default {
  title: "Form Button",
  type: "rh/components/form/button",
  config: {
    emptyLabel: "Form Button",
    isEmpty: (_: PropTypes) => false
  }
};
